import { type Config } from "react-player";

const playerConfig: Config = {
  wistia: {
    options: {
      controlsVisibleOnLoad: false,
      fitStrategy: "fill",
      doNotTrack: true,
    },
  },
  vidyard: {
    options: {
      type: "inline",
      autoplay: "0",
      first_frame: "1",
      disable_ctas: "1",
      loop: "0",
      // @ts-ignore
    } as any, // Types inconsistency (object required, however the target type handled by the Vidyard API is string)
  },
};

export default playerConfig;
